import React from 'react';
import styles from './CollectionCard.module.scss';
import { NavigateToInternalUrl } from '../../../../../utils/api.utils';
import { Routes } from '../../../../../types/constants';
import { HomeCollection } from '../../../../../types/home.types';

interface CollectionCardProps {
    collection: HomeCollection;
}

const CollectionCard = ({ collection }: CollectionCardProps) => {
    const buildCollectionUrl = () => {
        const params = new URLSearchParams();
        params.set('collectionId', collection.id);
        params.set('collection', collection.title);
        collection.tags
            .map((tag) => tag.trim())
            .filter((tag) => tag.length > 0)
            .forEach((tag) => params.append('tags', tag));

        return `${Routes.VIDEOS}?${params.toString()}`;
    };

    const collectionUrl = buildCollectionUrl();

    const handleBrowse = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        NavigateToInternalUrl(collectionUrl as Routes);
    };

    return (
        <a className={styles.card} href={collectionUrl} onClick={handleBrowse}>
            <img src={collection.imageUrl} alt={collection.title} className={styles.image} />
            <div className={styles.content}>
                <h3 className={styles.title}>{collection.title}</h3>
                <p className={styles.description}>{collection.description}</p>
                <span className={styles.cta}>Browse collection</span>
            </div>
        </a>
    );
};

export default CollectionCard;
